import { defineStore } from "pinia";
import axios, { AxiosResponse } from 'axios';
import { QueueItem, QueueQueryResult } from "@/types";
import { BFilter, BFilterableField } from "@/components/BFilterEditor/BFilterEditor.types";
import { BSortOptions, serializeSortBy } from "@/components/BTable/BTable.types";
import { serializeFilters } from "@/components/BTable/HelperFunctions";

export const useQueueStore = defineStore('queueStore', () => {  
    const apiUrl= "api/v1/queue/";
    
    function getQueueStatus(){
        return axios.get(`${apiUrl}status`, {params:{}});            
    }
    
    function getQueueItems(pageNumber:number, pageSize:number, filterInfo:BFilter[], filterableFields:BFilterableField[], sortingInfo:BSortOptions[] ):Promise<AxiosResponse<QueueQueryResult>> {
        
        let filterText = serializeFilters(filterInfo, filterableFields);
        let sortText = serializeSortBy(sortingInfo);
        
        return axios.get(`${apiUrl}page-number/${pageNumber}/page-size/${pageSize}`,{ params: { filter:filterText, sort:sortText }}); 
    }
    
    function changeQueueStatus(pauseQueue:boolean){
        return axios.post(`${apiUrl}set-paused`, { paused: pauseQueue})
    }
    
    return {getQueueStatus, getQueueItems, changeQueueStatus}
})